// extracted by mini-css-extract-plugin
module.exports = {"search-box":"search-box___1SHvN"};